import ProductLabel from "../../components/common/product-label";
import Science from "../../components/glucogen/science";
import VslVideo from "../../components/glucogen/vsl/vsl-video";
import usePageTracking from "../../utils/gtm-page-tracking";
import productLabelImg from "../../assets/img/product-gg-label-bottle.png";
import productLabelImgWebp from "../../assets/img/product-gg-label-bottle.webp";
import { useNameDrop } from "../../context/NameDropContext";
import Buy from "../../components/glucogen/buy";
import CountdownTimer from "../../components/common/countdown";
import { useEffect } from "react";
import { ggProductName } from "../../data/product";
import MoneyBackGuarantee from "../../components/common/money-back-guarantee";
import Faq from "../../components/glucogen/faq";
import { glucoGenIngredients } from "../../data/ingredients";
import Ingredients from "../../components/common/ingredients";
import Gifts from "../../components/glucogen/gifts";
import TestimonialsMain from "../../components/glucogen/testimonials-main";
import Badges from "../../components/common/badges";
import Benefits from "../../components/glucogen/benefits";
import ImportantMessage from "../../components/glucogen/important-message";
import useScrollToHash from "../../utils/scroll-to-hash";

const Vsl4Page = () => {
    usePageTracking();
    useScrollToHash();
    const { isNameDropSeen } = useNameDrop();
    useEffect(() => {
        const script1 = document.createElement('script');
        script1.innerHTML = `
            var mysrc = "https://tracking.buygoods.com/track/?a=11273&firstcookie=0"+"&tracking_redirect=&referrer="+encodeURIComponent(document.referrer)+"&sessid2="+ReadCookie('sessid2')+"&product=glu1,glu3,glu6&vid1=&vid2=&vid3=&caller_url="+encodeURIComponent(window.location.href); if(typeof add_to_cart !== 'undefined') { mysrc = mysrc+'&add_to_cart='+add_to_cart; } var newScript = document.createElement('script'); newScript.type = 'text/javascript'; newScript.defer = true; newScript.src = mysrc; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(newScript, s); function ReadCookie(name){name += '='; var parts = document.cookie.split(/;\s*/);for (var i = 0; i < parts.length; i++) {var part = parts[i]; if (part.indexOf(name) == 0) return part.substring(name.length)} return '';}
        `;
        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.innerHTML = `
            setTimeout(function () {var i = document.createElement("iframe"),oid = new URLSearchParams(window.location.search);i.async = true;i.style="display:none";i.setAttribute("src", "https://buygoods.com/affiliates/go/conversion/iframe/bg?a=11273&t=d9e2485e36c8c19cbfc7f6acfe589a47&s="+ReadCookie('sessid2'));document.body.appendChild(i);}, 1000);
        `;

        document.head.appendChild(script1);
        document.head.appendChild(script2);

        return () => {
            document.head.removeChild(script1);
            document.head.removeChild(script2);
        };
    }, []);

    return (
        <>
            <VslVideo
                vidalyticsId="vidalytics_embed_2Alq4Zrh4yKHwCbl"
                vidalyticsUrl="https://fast.vidalytics.com/embeds/g6Z8uQvx/2Alq4Zrh4yKHwCbl/"
                nameDropTime={27 * 60 + 24}
                title="The issue isn’t the sugar, the bread, or even the pasta."
                subtitle="You’ve been blaming your food. But what if it’s something else entirely?"
            />
            <Buy
                isShown={isNameDropSeen}
                showExtraLinks={true}
            />
            {isNameDropSeen &&
                <>
                    <ImportantMessage />
                    <Benefits />
                    <Badges />
                    <TestimonialsMain />
                    <Gifts />
                    <CountdownTimer
                        title={`Get your ${ggProductName} supply today`}
                        backgroundClass=""
                        digitClass="gg-countdown-digit"
                    />
                </>
            }
            <Buy
                isShown={isNameDropSeen}
                showExtraLinks={true}
            />
            {isNameDropSeen &&
                <>
                    <Ingredients
                        ingredients={glucoGenIngredients}
                        backgroundClass="gg-bg-solid-green"
                        title="This original blend of GlucoGen<sup>17</sup> Naturals contains 17 carefully selected ingredients including:"
                    />
                    <Faq />
                </>
            }
            <Buy
                isShown={isNameDropSeen}
                showExtraLinks={true}
            />
            {isNameDropSeen &&
                <MoneyBackGuarantee
                    backgroundClass="gg-bg-gradient-rb-h"
                    productName={ggProductName}
                />
            }
            <Science />
            {isNameDropSeen &&
                <ProductLabel
                    image={productLabelImg}
                    imageWebp={productLabelImgWebp}
                    backgroundClass="gg-bg-gradient-v"
                />
            }
        </>
    );
};

export default Vsl4Page;